<template>
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
        d="M5.5 10.5C8.26142 10.5 10.5 8.26142 10.5 5.5C10.5 2.73858 8.26142 0.5 5.5 0.5C2.73858 0.5 0.5 2.73858 0.5 5.5C0.5 8.26142 2.73858 10.5 5.5 10.5Z"
        stroke="#111111" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M7 4L4 7" stroke="#111111" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M4 4L7 7" stroke="#111111" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script>
export default {
  name: 'Close',
};
</script>
